// extracted by mini-css-extract-plugin
export default {"section":"HistoryLayout_section__w477o","inputContainer":"HistoryLayout_inputContainer__7q6gq"};